<section class="support-ai-window" *ngIf="open" role="dialog" aria-label="QwikCut AI Support">
	<header class="support-ai-header">
		<div class="support-ai-heading">
			<strong>QwikCut AI Support</strong>
			<span>Answers can be incorrect. Verify important details.</span>
		</div>
		<div class="scope-selector" *ngIf="config?.canChooseScope" aria-label="Support scope">
			<button type="button" *ngFor="let scope of adminScopes"
				[class.active]="selectedScope === scope"
				[disabled]="!config.availableScopes.includes(scope)"
				[attr.aria-pressed]="selectedScope === scope"
				[attr.title]="scope === 'team' && !config.availableScopes.includes('team') ? 'Select an active team to use team scope' : null"
				(click)="changeScope(scope)">{{ scopeLabel(scope) }}</button>
		</div>
		<span class="scope-badge" *ngIf="!config?.canChooseScope">{{ scopeLabel(selectedScope) }}</span>
		<button mat-icon-button aria-label="Close AI Support" (click)="close()"><mat-icon>close</mat-icon></button>
	</header>

	<div class="support-ai-body">
		<aside class="conversation-list" aria-label="Support conversations">
			<button mat-stroked-button color="primary" (click)="newConversation()">New conversation</button>
			<button class="conversation" *ngFor="let conversation of conversations"
				[class.active]="activeConversation?._id === conversation._id" (click)="selectConversation(conversation)">
				<span>{{ conversation.title }}</span><small>{{ scopeLabel(conversation.scope) }}</small>
				<mat-icon (click)="removeConversation(conversation, $event)" aria-label="Delete conversation">delete_outline</mat-icon>
			</button>
		</aside>

		<main class="chat-panel">
			<div class="active-scope">{{ scopeLabel(activeConversation?.scope || selectedScope) }} scope</div>
			<div #messagesContainer class="messages" aria-live="polite">
				<div class="empty-state" *ngIf="!messages.length && !loading">
					<strong>How can we help?</strong>
					<p>{{ emptyStateDescription() }}</p>
				</div>
				<article *ngFor="let message of messages" class="message" [class.user]="message.role === 'user'">
					<div class="message-content">{{ message.content }}</div>
					<ul *ngIf="message.suggestedActions?.length">
						<li *ngFor="let action of message.suggestedActions">{{ action }}</li>
					</ul>
					<div class="evidence" *ngIf="message.evidence?.length">
						<span *ngFor="let evidence of message.evidence">{{ evidence.label }} · {{ evidence.checkedAt | date:'short' }}</span>
					</div>
					<div class="message-actions" *ngIf="message.role === 'assistant' && message._id">
						<button mat-icon-button aria-label="Helpful answer" (click)="rate(message, 'up')"><mat-icon>thumb_up_off_alt</mat-icon></button>
						<button mat-icon-button aria-label="Unhelpful answer" (click)="rate(message, 'down')"><mat-icon>thumb_down_off_alt</mat-icon></button>
					</div>
				</article>
				<div class="support-status" *ngIf="loading && status"><mat-spinner diameter="18"></mat-spinner>{{ status }}</div>
				<div class="support-error" *ngIf="error" role="alert">{{ error }}</div>
			</div>

			<footer>
				<textarea [(ngModel)]="draft" maxlength="4000" rows="2" aria-label="Message AI Support"
					placeholder="Ask QwikCut Support..." (keydown)="onKeydown($event)" [disabled]="loading"></textarea>
				<div class="footer-actions">
					<button mat-button *ngIf="humanHandoffEnabled" (click)="contactHuman()" [disabled]="loading">Contact Human Support</button>
					<span>{{ draft.length }}/4000</span>
					<button mat-flat-button color="primary" (click)="send()" [disabled]="loading || !draft.trim()">Send</button>
				</div>
			</footer>
		</main>
	</div>
</section>
